import type { FirebaseError } from 'firebase/app';

export default function firebaseErrorCodesMap(error: FirebaseError) {
  switch (error.code) {
    case 'auth/account-exists-with-different-credential':
    case 'auth/invalid-email':
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-login-credentials':
      return 'errorWrongCreds';
    case 'auth/invalid-credential':
      return 'errorBackend';
    case 'auth/user-disabled':
      return 'errorUserDisabled';
    case 'auth/popup-closed-by-user':
      return 'errorPopupClosedByUser';
    case 'auth/user-cancelled':
      return 'errorUserCancelled';
    case 'auth/network-request-failed':
      return 'errorNetworkRequestFailed';
    case 'auth/popup-blocked':
      return 'errorPopupBlocked';
    case 'auth/operation-not-supported-in-this-environment':
      return 'errorOperationNotSupported';
    case 'auth/unauthorized-domain':
      return 'errorDomainNotAllowed';
    case 'auth/operation-not-allowed':
      return 'errorOperationNotAllowed';
    case 'auth/too-many-requests':
      return 'errorTooManyRequests';
    case 'auth/invalid-verification-code':
      return 'errorInvalidVerificationCode';
    case 'auth/second-factor-already-in-use':
      return 'errorUsedSecondFactor';
    case 'auth/internal-error': {
      const match = error.message.match(/\{.*\}/);
      if (!match) return 'errorInternalError';
      try {
        const { error: err } = JSON.parse(match[0]);
        const { code } = JSON.parse(err.message);
        return code ?? 'errorInternalError';
      } catch {
        return 'errorInternalError';
      }
    }
    default:
      return 'errorUnexpectedError';
  }
}
